import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'
import { isSuccessResponse } from '../utils'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)

  return data?.map((item: any) => {
    return {
      id: item?.id,
      key: item?.key ?? '',
      type: item?.type ?? '',
      className: item?.className ?? '',
      username: item?.username ?? '',
      approvalType: item?.approvalType ?? '',
      approvalStatus: item?.approvalStatus ?? '',
      data: {
        type: 'routing',
        id: item?.object?.id,
        ruleName: item?.object?.ruleName,
        payeeType: item?.object?.payeeType,
        payeeUserId: item?.object?.payeeUserId,
        payeeVpa: item?.object?.payeeVpa,
        payerBankId: item?.object?.payerBankId,
        binList: item?.object?.binList,
        binRange: item?.object?.binRange,
        cardType: '' + item?.object?.cardType,
        scheme: '' + item?.object?.scheme,
        amount: item?.object?.amount,
        transactionInitiatingEntityId: '' + item?.object?.transactionInitiatingEntityId,
        transactionApplication: item?.object?.transactionApplication,
        txntype: '' + item?.object?.txntype,
        instrumentType: '' + item?.object?.instrumentType,
        mode: item?.object?.mode,
        activationGroup: item?.object?.activationGroup,
        priority: item?.object?.priority,
        processor: item?.object?.processor,
        isActive: item?.object?.isActive,
        isAssigned: item?.object?.isAssigned,
      },
    }
  })
}

const getFeePackageApprovalsReq = (elevated: boolean, tokens: any, fileType: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.staticRoutingApprovals),
    method: 'GET',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      elevated,
      fileType
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getFeePackageApprovalsReq }
